/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState } from 'react';
import { Typography, Box, Button } from '@mui/material';
import imgProfileUser from '/images/user-profile.svg';
import { Navigate, useNavigate } from 'react-router-dom';
import { styles } from './style';
import { useUploadProfile } from '../../../../hooks/queries/useUploadProfile';
import { useAppSelector } from '../../../../redux/hooks';
import { triggerSnackbar } from '../../../../provider/SnackbarProvider';
import LoginRegistrationHeader from '../../../../components/layout/LoginRegistrationHeader';

function UpdateProfile({ onNext }: any) {
  const navigate = useNavigate();
  const userId = useAppSelector((state) => state.auth.currentUser?.id);
  const profileURL =
    useAppSelector((state) => state.auth.currentUser?.profile_url) || '';

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string | null>(
    profileURL
  );

  const { mutate, isPending } = useUploadProfile();

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedFile = event.target.files && event.target.files[0];
    if (selectedFile) {
      const validTypes = ['image/png', 'image/jpeg'];
      if (validTypes.includes(selectedFile?.type)) {
        setFile(selectedFile);
        setImagePreviewUrl(URL.createObjectURL(selectedFile));
      } else {
        triggerSnackbar({
          message: 'Invalid file type. Only .png and .jpg formats are allowed.',
          severity: 'error',
        });
      }
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onNext();
  };

  const handleUpload = async () => {
    if (file && userId) {
      mutate(
        {
          file,
          userId,
        },
        {
          onSuccess: () => {
            setFile(null);
            navigate('/explore', { replace: true });
          },
        }
      );
    }
  };

  if (profileURL) {
    return <Navigate to={'/explore'} replace />;
  }

  return (
    <form className="d-flex flex-column flex-1" onSubmit={handleSubmit}>
      <LoginRegistrationHeader showBackArrow={false} />
      <Box pt={5} mb={7.25}>
        <Typography variant="h4" color="primary" mb={1.5}>
          Add a profile picture
        </Typography>
        <Typography variant="body1">
          Upload a profile picture to help your clinician and hospital staff
          easily recognize you. If you skip, you can still add it to your
          profile later.
        </Typography>
      </Box>
      <Box
        sx={styles.profileBox}
        className="d-flex align-items-center justify-content-center overflow-hidden"
      >
        {/* Show the uploaded image preview or the default profile image */}
        <img
          src={imagePreviewUrl || imgProfileUser}
          alt="profile"
          style={{
            width: !imagePreviewUrl ? '104px' : '100%',
            objectFit: 'cover',
          }}
          onClick={handleButtonClick}
        />
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </Box>
      <Box sx={{ pt: 7.5, mt: 'auto', mb: 4.5 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mb: 1.5 }}
          disabled={isPending}
          onClick={file ? handleUpload : handleButtonClick}
        >
          {file ? 'Upload' : 'Add picture'}
        </Button>
        <Button
          variant="outlined"
          type="submit"
          fullWidth
          onClick={() => {
            navigate('/explore');
          }}
        >
          Skip for now
        </Button>
      </Box>
    </form>
  );
}

export default UpdateProfile;
